<template>
  <v-main role="presentation" class="white_background">
    <v-container class="text-center">
      <v-row>
        <v-col cols="12" text-right class="mb-4 pb-4">
          <div class="languageSelector">
            <LocaleSelector />
          </div>
        </v-col>
      </v-row>
      <v-row class="widthForContent mt-4 pt-4">
        <v-col class="text-center mt-4 mb-4">
          <v-row>
            <v-col cols="12" class="text-center mt-4 mb-4">
              <v-img src="@/assets/primerica-logo.svg" height="70" alt="Primerica Beta" />
            </v-col>
          </v-row>
          <div
            class="mx-auto mb-xs-12"
            :class="$vuetify.display.xs ? 'overall-div-card-smaller' : 'overall-div-card-larger'"
          >
            <v-row ml-4 mr-4>
              <v-col class="text-center" cols="12" mt-4>
                <span mb-4 class="css_app_update">
                  {{ $t('L_app_update') }}
                </span>
              </v-col>
              <v-col cols="12" text-xs-left mt-4 mb-4 ml-4 mr-4 class="regular_body_text">
                {{ $t('L_we_have_recently_added_some_updates') }}
              </v-col>
              <v-col cols="12" text-xs-left mb-4 ml-4 mr-4 pb-4 class="regular_body_text">
                {{ $t('L_it_looks_like_your_current_version_is_out_of_date') }}
              </v-col>
            </v-row>
          </div>
          <v-row class="text-center outerlayout">
            <div class="innerLayout">
              <v-col cols="12" mb-4>
                <OnexButton
                  block
                  ml-4
                  mr-4
                  pl-4
                  pr-4
                  color="primary"
                  class="btn_default"
                  @click="goToUpdate"
                  target="_blank"
                >
                  {{ $t('L_update_now') }}
                </OnexButton>
              </v-col>
              <v-col cols="12" v-if="enableSkipButton">
                <OnexButton block class="btn_default btn_white ml-4 mr-4 pl-4 pr-4" @click="skip">
                  {{ $t('L_later') }}
                </OnexButton>
              </v-col>
            </div>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script lang="ts">
import { openInNewWindow } from '@//mixins/openNewWindow';
import { defineComponent, type ComponentOptions } from 'vue';
import { mapStores } from 'pinia';
import { useGlobalStore } from '@/stores/global/global.store';
import { CapacitorFacade } from '@/plugins/capacitorPlugin';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { OnexButton } from '@primerica/onex-ui-lib';
import { RouteNames } from '@/router/routeNames';
import LocaleSelector from '@/components/LocaleSelector/LocaleSelector.vue';

const componentOptions: ComponentOptions = {
  name: 'AppUpdate',
  components: {
    OnexButton,
    LocaleSelector,
  },
  mixins: [openInNewWindow],
  computed: {
    ...mapStores(useGlobalStore, useCustomerStore),
    enableSkipButton() {
      return !this.globalStore.isCriticalUpdateAvailable;
    },
  },
  methods: {
    async goToUpdate() {
      let embedUrl = '';
      if (CapacitorFacade.isAndroid()) {
        embedUrl = this.globalStore.getAndroidPlayStoreLink;
      } else if (CapacitorFacade.isIos()) {
        embedUrl = this.globalStore.getiOSStoreLink;
      }
      await this.openInNewWindow({ url: embedUrl, target: '_blank' });
    },
    skip() {
      if (this.globalStore.isMaintenanceMode) {
        this.$router.push({ name: RouteNames.MAINTENANCE_MODE });
      } else {
        this.$router.push({ name: RouteNames.DASHBOARD });
      }
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.background {
  min-height: 100%;
  background-image: linear-gradient(to top, #607c97, #063562);
}

.white_background {
  min-height: 100%;
  background-color: white;
}

.css_locale {
  background-color: white;
}

.css_app_update {
  font-size: 20px;
  font-weight: bold;
}

.regular_body_text {
  font-size: 20px;
}

.language-icon {
  color: white !important;
}

.container {
  max-width: 960px !important;
}

.widthForContent {
  max-width: 600px !important;
  margin: auto;
}

.btn_default {
  min-width: 250px;
  max-width: 350px;
  margin: auto;
  height: 48px;
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  color: white !important;
}

.outerlayout {
  padding-bottom: 50px;
}

.innerLayout {
  margin: auto !important;
}

.btn_white {
  background-color: white !important;
  color: black !important;
}

.languageSelector {
  position: absolute;
  left: 0px;
}
</style>
